export const getSrcSetString = ({ url, quality = 60, widths = [60, 120] }) => {
    if (!url) {
        return url;
    }
    return widths
        .map(
            (width, index) =>
                `${url}?disable=upscale&auto=webp&srcset=disallow&quality=${quality}&width=${width} ${index +
                    1}x`
        )
        .join(', ');
};

// Should only be used for images uploaded via cms, since we do not know the widths of those images
export const getSrcString = ({ url }) => {
    return `${url}?disable=upscale&auto=webp&quality=60`;
};
